
import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import onboardingSteps from "./data";
import Timeline from "./Timeline";
import Spinner from "../Spinner/Spinner";
import StepActive1 from "../../images/onboard_svgs/StepActive1.svg";
import StepInactive1 from "../../images/onboard_svgs/StepInactive1.svg";
import StepActive2 from "../../images/onboard_svgs/StepActive2.svg";
import StepInactive2 from "../../images/onboard_svgs/StepInactive2.svg";
import StepActive3 from "../../images/onboard_svgs/StepActive3.svg";
import StepInactive3 from "../../images/onboard_svgs/StepInactive3.svg";
import StepActive4 from "../../images/onboard_svgs/StepActive4.svg";
import StepInactive4 from "../../images/onboard_svgs/StepInactive4.svg";
import { useAuth } from "../../context/AuthContext";
import authAPI from "../../api/auth";
import * as amplitude from '@amplitude/analytics-browser';


const OnboardingStep = () => {
    const navigate = useNavigate();
    const nextButtonRef = useRef(null);
    const { user, setUser } = useAuth();
    const location = useLocation();



    const [currentStep, setCurrentStep] = useState(1);
    const [stepsData, setStepsData] = useState(onboardingSteps);
    const [stepData, setStepData] = useState(stepsData.find((step) => step?.step === currentStep));
    const [selectedAnyOption, setSelectedAnyOption] = useState(true);
    const [savingData, setSavingData] = useState(false);
    const [skippedLastStep, setSkippedLastStep] = useState(false);
    const [timelineStepsData, setTimelineStepsData] = useState([
        { id: 1, label: "Connect Your Email", isSelected: false, isSkipped: false, isCurrent: true },
        { id: 2, label: "Connect Your Calendar", isSelected: false, isSkipped: false, isCurrent: false },
        { id: 3, label: "Connect Your Meeting Recorder", isSelected: false, isSkipped: false, isCurrent: false },
        { id: 4, label: "Connect Your File Storage", isSelected: false, isSkipped: false, isCurrent: false },
    ]);
    const [stepIcons, setStepIcons] = useState({
        current: [StepActive1, StepActive2, StepActive3, StepActive4],
        pending: [StepInactive1, StepInactive2, StepInactive3, StepInactive4],
    });

    const skipOnboardingProcessHandler = (time) => {
        setTimeout(() => {
            navigate(`/companies`)
        }, time || 3000)
    };

    const localStorageSetterHandler = () => {
        localStorage.setItem("isUserOnboardingDone", true);
    }

    const onboardingHandler = async () => {
        setSavingData(true);
        try {
            // const response = await authAPI.onboarding();
            // console.log(`response onboarding`, response);
            // if (response?.statusCode === 200) {
                // localStorageSetterHandler();
            navigate('/signup')
            // }
        } catch (error) {
            console.log("Error in onboarding :", error);
        } finally {
            setSavingData(false);
        }
    };

    const handleConnectionToggle = async (index, option) => {
        // console.log("handleConnectionToggle index", index);
        // console.log("handleConnectionToggle option", option);
        if (option?.status === 'connected') {
            return;
        }

        const updateStepData = (updatedOptions) => {
            const isAnyConnected = updatedOptions.some((opt) => opt.status === "connected");

            setStepData((prevData) => ({ ...prevData, options: updatedOptions }));
            setSelectedAnyOption(isAnyConnected);

            setTimelineStepsData((prevTimeline) =>
                prevTimeline.map((step) =>
                    step.status === "current"
                        ? { ...step, status: isAnyConnected ? "completed" : "current" }
                        : step
                )
            );

            setStepsData((prevSteps) =>
                prevSteps.map((step) =>
                    step.step === currentStep
                        ? { ...step, options: updatedOptions, skipped: false }
                        : step
                )
            );
        };

        if (option?.name === "Gmail") {

            // Track Gmail connection attempt in Amplitude
            amplitude.track('Gmail Connection Attempt', {
                step: currentStep,
                connectionType: 'Gmail',
                userEmail: user?.email
            });

            window.location.href = `${process.env.REACT_APP_API_URL}/auth/google?${new URLSearchParams({ action: 'signup' })}`;

            // const popupUrl = `${process.env.REACT_APP_API_URL}/auth/google?action=signup`;
            // window.location.href = popupUrl

            // const gmailPopup = window.open(
            //     popupUrl,
            //     "GmailAuth",
            //     `width=600,height=600,left=${window.innerWidth / 2 - 300},top=${window.innerHeight / 2 - 300}`
            // );

            // const messageListener = (event) => {
            //     if (event.origin !== process.env.REACT_APP_API_URL) return;

            //     if (event.data.status === 200) {
            //         console.log("Received success response from backend.");
            //         gmailPopup?.close();

            //         setStepData((prevData) => {
            //             const updatedOptions = prevData.options.map((opt, i) =>
            //                 i === index ? { ...opt, status: opt.status === "connected" ? "connect" : "connected" } : opt
            //             );
            //             updateStepData(updatedOptions);
            //             return { ...prevData, options: updatedOptions };
            //         });
            //     } else {
            //         gmailPopup?.close();
            //     }
            //     window.removeEventListener("message", messageListener);
            // };

            // window.addEventListener("message", messageListener);
        } else {
            setStepData((prevData) => {
                const updatedOptions = prevData.options.map((opt, i) =>
                    i === index ? { ...opt, status: opt.status === "connected" ? "connect" : "connected" } : opt
                );
                updateStepData(updatedOptions);
                return { ...prevData, options: updatedOptions };
            });
        }

        if (option?.name === "Google Calendar") {
            amplitude.track('Google Calendar Connection Attempt', {
                step: currentStep,
                connectionType: 'Google Calendar',
                userEmail: user?.email
            });
        
            // Modify the URL to include an action parameter (e.g., 'connect' or 'signup')
            const popupUrl = `${process.env.REACT_APP_API_URL}/auth/googleCalender?${new URLSearchParams({
                popup: 'true',
                action: 'calenderConnection'  // Change 'connect' to any action you need
            })}`;
        
            const calendarPopup = window.open(
                popupUrl,
                "GoogleCalendarAuth",
                `width=600,height=600,left=${window.innerWidth / 2 - 300},top=${window.innerHeight / 2 - 300}`
            );
        
            const messageListener = (event) => {
                if (event.origin !== process.env.REACT_APP_API_URL) return;
        
                if (event.data.status === 200) {
                    console.log("Google Calendar connected successfully.");
                    calendarPopup?.close();
        
                    setStepData((prevData) => {
                        const updatedOptions = prevData.options.map((opt, i) =>
                            i === index ? { ...opt, status: "connected" } : opt
                        );
                        updateStepData(updatedOptions);
                        return { ...prevData, options: updatedOptions };
                    });
                } else {
                    calendarPopup?.close();
                }
                window.removeEventListener("message", messageListener);
            };
        
            window.addEventListener("message", messageListener);
        }
        
        if (option?.name === "Google Drive") {
            amplitude.track('Google Drive Connection Attempt', {
                step: currentStep,
                connectionType: 'Google Drive',
                userEmail: user?.email
            });
        
            // Modify the URL to include an action parameter (e.g., 'connect' or 'signup')
            const popupUrl = `${process.env.REACT_APP_API_URL}/auth/googleDrive?${new URLSearchParams({
                popup: 'true',
                action: 'driveConnection'  // Change 'connect' to any action you need
            })}`;
        
            const calendarPopup = window.open(
                popupUrl,
                "GoogleDriveAuth",
                `width=600,height=600,left=${window.innerWidth / 2 - 300},top=${window.innerHeight / 2 - 300}`
            );
        
            const messageListener = (event) => {
                if (event.origin !== process.env.REACT_APP_API_URL) return;
        
                if (event.data.status === 200) {
                    console.log("Google Drive connected successfully.");
                    calendarPopup?.close();
        
                    setStepData((prevData) => {
                        const updatedOptions = prevData.options.map((opt, i) =>
                            i === index ? { ...opt, status: "connected" } : opt
                        );
                        updateStepData(updatedOptions);
                        return { ...prevData, options: updatedOptions };
                    });
                } else {
                    calendarPopup?.close();
                }
                window.removeEventListener("message", messageListener);
            };
        
            window.addEventListener("message", messageListener);
        }
        
    };

    const getButtonStyles = (status) => {
        switch (status) {
            case "connected": return "bg-[#cb90fc] text-[#45185a]";
            // hover:bg-[#5e2c73] hover:text-[#cb90fc]";
            case "coming-soon": return "bg-[#ebedf0] text-gray-400 cursor-not-allowed";
            default: return "bg-[#45185a] text-[#cb90fc]";
            // hover:bg-[#5e2c73] hover:text-[#cb90fc]";
        }
    };

    const getButtonText = (status) => {
        switch (status) {
            case "connected": return "Connected";
            case "coming-soon": return "Coming Soon";
            default: return "Connect";
        }
    };




    const nextStepHandler = async (val) => {
        if (val) {
            await onboardingHandler();
        } else if (selectedAnyOption || stepsData.find((step) => step.step === currentStep)?.skipped) {
            setCurrentStep((prev) => prev + 1);
            setSelectedAnyOption(false);

            setTimelineStepsData((prev) =>
                prev.map((step) => ({
                    ...step,
                    status: step.id === currentStep
                        ? "completed"
                        : step.id === currentStep + 1
                            ? "current"
                            : step.status
                }))
            );
        }
    };

    const prevStepHandler = () => {
        setCurrentStep((prev) => Math.max(prev - 1, 1));
    };

    const handleSkipCurrentStep = () => {
        setCurrentStep((prev) => prev + 1);
        setSelectedAnyOption(false);

        setStepsData((prevSteps) =>
            prevSteps.map((step) =>
                step.step === currentStep ? { ...step, skipped: true } : step
            )
        );
        const updatedTimelineSteps = timelineStepsData.map((step, index) => ({
            ...step,
            isCurrent: step.id === currentStep + 1 ? true : false,
        }));
        setTimelineStepsData(updatedTimelineSteps);
    };

    const handleSkipLastStepAndSave = async () => {

        setSkippedLastStep(true);
        setStepsData((prevSteps) =>
            prevSteps.map((step) =>
                step.step === currentStep ? { ...step, skipped: true } : step
            )
        );
        await onboardingHandler();
    };

    useEffect(() => {
        const currentStepData = stepsData.find((step) => step?.step === currentStep);
        setStepData(currentStepData);
        setSelectedAnyOption(currentStepData?.options.some(option => option.status === "connected"))
        const updatedTimelineSteps = timelineStepsData.map((step, index) => ({
            ...step,
            isCurrent: step.id === currentStep ? true : false,
        }));
        setTimelineStepsData(updatedTimelineSteps);
    }, [currentStep]);

    useEffect(() => {
        if (stepsData && stepsData.length === timelineStepsData.length) {
            const updatedTimelineSteps = timelineStepsData.map((step, index) => ({
                ...step,
                isSkipped: stepsData[index].skipped,
                isSelected: stepsData[index].options?.some((option) => option.status === "connected") || false,
            }));
            setTimelineStepsData(updatedTimelineSteps);
        }
    }, [stepsData]);


    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === "Enter") {
                event.preventDefault(); // Prevent default form submission
                if (nextButtonRef.current) {
                    nextButtonRef.current.click(); // Trigger button click
                }
            }
        };

        // Attach the event listener
        document.addEventListener("keydown", handleKeyDown);

        // Clean up the event listener
        return () => {
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, []);



    useEffect(() => {
        console.log(`Onboarding screen user ==>>`, user)
        if (user?.isGmailConnected) {
            setStepsData((prevSteps) =>
                prevSteps.map((step) =>
                    step.step === 1
                        ? {
                            ...step,
                            options: step.options.map((option) =>
                                option.name === "Gmail"
                                    ? { ...option, status: "connected" }
                                    : option
                            ),
                        }
                        : step
                )
            );
            setSelectedAnyOption(true)
        }
    }, [user, location.state]);

    useEffect(() => {
        if (user?.isGmailConnected && user?.email) {
            // Set user identity in Amplitude
            amplitude.setUserId(user.email);
            amplitude.track('Gmail Connection Success', {
                step: currentStep,
                connectionType: 'Gmail',
                userEmail: user.email
            });
        }
    }, [user?.isGmailConnected, user?.email, currentStep]);

    useEffect(() => {
        setStepData(stepsData.find((step) => step?.step === currentStep))
    }, [stepsData])


    // console.log(`stepsData ========>>>>`, stepsData)

    if (!stepData) return <div>Invalid step</div>;

    return (
        <div className="w-full bg-white flex add-background-image respomsive-in-full-flex-null">
            <div className="flex flex-col p-6 shadow-md rounded-lg w-full max-w-[25%] mx-auto h-screen respomsive-in-full">
                <Timeline steps={timelineStepsData} stepIcons={stepIcons} activeTab={currentStep} />
            </div>
            <div className="flex flex-col py-6 px-16 bg-white shadow-md rounded-lg w-full max-w-[75%] h-screen respomsive-in-full">
                <header className="mb-6">
                    <div className="w-full flex items-start justify-between">
                        <h2 className="text-[2.03rem] font-extrabold text-black">{stepData?.title}</h2>
                        <button onClick={() => skipOnboardingProcessHandler(1)} className="text-gray-400 font-semibold text-lg">
                            ✕
                        </button>
                    </div>
                    <p className="text-black font-medium text-sm mt-2">{stepData?.description}</p>
                </header>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 mt-5 mb-5 mr-12 h-[75%] overflow-y-auto scrollbar-none">
                    {stepData?.options?.map((option, index) => {
                        return (
                            <div key={index} className={`py-6 px-5 border rounded-xl border-[#dedbdb] h-fit`}>
                                <div className="mb-2 flex items-center gap-2 py-2">
                                    <img src={option?.icon || ""} alt={option?.name || "icon"} style={{ height: `${option?.maxHeight || 2.3}rem`, marginLeft: `${option?.imgMrgLeft || 0}px` }} />
                                    <h3 className="font-nunito text-xl font-bold text-gray-900" style={{ marginLeft: `${option?.mrgLeft || 0}px` }}>{option?.name || "Option"}</h3>
                                </div>
                                <div className="w-full py-2">
                                    <button
                                        className={`w-full py-2 px-4 rounded text-sm font-semibold ${getButtonStyles(option?.status)}`}
                                        disabled={option?.status === "coming-soon"}
                                        onClick={() => handleConnectionToggle(index, option)}
                                    >
                                        {getButtonText(option?.status)}
                                    </button>
                                </div>
                            </div>
                        )
                    }
                    )}
                </div>

                <footer className={`pt-4 mt-auto flex ${currentStep === 1 ? `justify-end` : `justify-between`}`}>
                    {currentStep > 1 && (
                        <button className="cursor-pointer px-4 py-2 bg-[#EAEAEA] text-[#5C5E63] font-bold rounded shadow" onClick={prevStepHandler}>
                            Back
                        </button>
                    )}
                    <div className="flex items-center gap-8">
                        {savingData && skippedLastStep && (
                            <span className="text-gray-400 cursor-not-allowed">Skip, and save</span>
                        )}
                        {savingData
                            ? <div className="flex items-center gap-2">
                                <span className="text-[#45185a] cursor-not-allowed">Saving...</span>
                                <Spinner />
                            </div>
                            : currentStep === 1 ? ''
                                : currentStep === stepsData.length ?
                                    selectedAnyOption ? (
                                        <span className="text-gray-400 cursor-not-allowed">Skip, and save</span>
                                    ) : stepsData.find((step) => step.step === currentStep)?.skipped ? (
                                        <span className="text-red-500 ml-4">Skipped</span>
                                    ) : (
                                        <span className="text-[#45185a] cursor-pointer" onClick={handleSkipLastStepAndSave}>Skip, and save</span>
                                    ) : selectedAnyOption ? (
                                        <span className="text-gray-400 cursor-not-allowed">Skip for now</span>
                                    ) : stepsData.find((step) => step.step === currentStep)?.skipped ? (
                                        <span className="text-red-500 ml-4">Skipped</span>
                                    ) : (
                                        <span className="text-[#45185a] cursor-pointer" onClick={handleSkipCurrentStep}>Skip for now</span>
                                    )}

                        {skippedLastStep ? '' :
                            <button
                                ref={nextButtonRef}
                                className={`${(!selectedAnyOption && !stepsData.find((step) => step.step === currentStep)?.skipped) || savingData
                                    ? `bg-[#ebedf0] text-gray-400 cursor-not-allowed`
                                    : `bg-[#45185a] text-white`
                                    } px-4 py-2 font-bold rounded shadow`}
                                disabled={!selectedAnyOption && !stepsData.find((step) => step.step === currentStep)?.skipped}
                                onClick={() => nextStepHandler(currentStep === stepsData.length ? 'last' : '')}
                            >
                                {currentStep === stepsData.length ? "Save" : "Next"}
                            </button>
                        }
                    </div>
                </footer>
            </div>
        </div >
    );
};

export default OnboardingStep;

